module.exports = "fragment HotlineQuestionAnswer on HotlineQuestionAnswerType{__typename id rowId text}"